// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import Swiper from "swiper/bundle";

//--------------------------------------------------------------------//

import "./slider-tabs.scss";

const sliderTabs = () => {
    let allSliderWrap = document.querySelectorAll(".info-wrapper");

    if (!allSliderWrap.length) return;

    let preInfo = document.querySelector("#pre-info");

    allSliderWrap.forEach((el, i) => {
        let sliderTab = el.querySelector(".slider-tabs");

        let sliderTabSwiper = new Swiper(
            sliderTab.querySelector(".slider-tabs .swiper-container"),
            {
                slidesPerView: "auto",
                slideToClickedSlide: true,
                freeMode: true,
                observer: true,
                observeParents: true,

                a11y: {
                    enabled: true,
                    prevSlideMessage: "Previous slide",
                    nextSlideMessage: "Next slide",
                    firstSlideMessage: "This is the first slide",
                    lastSlideMessage: "This is the last slide",
                    paginationBulletMessage: "Go to slide {{index}}",
                    notificationClass: "swiper-notification",
                },
            }
        );

        let tabs = sliderTab.querySelectorAll(".swiper-slide");

        const scrollToTop = (el) => {
            preInfo.scrollIntoView(true);
        };

        let observer = new IntersectionObserver(
            ([el]) => {
                if (el.intersectionRatio < 1) {
                    tabs.forEach((el, i) => {
                        el.addEventListener("click", scrollToTop);
                    });
                } else {
                    tabs.forEach((el, i) => {
                        el.removeEventListener("click", scrollToTop);
                    });
                }
            },
            { threshold: [1] }
        );

        if (window.innerWidth <= 767) {
            observer.observe(sliderTab);
        }

        let boxInfo = el.querySelector(".box-info");

        if (!boxInfo) {
            return;
        } else {
            let sliderBoxInfo = new Swiper(
                el.querySelector(".box-info .swiper-container"),
                {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    simulateTouch: false,
                    allowTouchMove: false,
                    speed: 600,
                    effect: "fade",
                    autoHeight: true,
                    observer: true,
                    observeParents: true,
                    thumbs: {
                        swiper: sliderTabSwiper,
                    },
                    fadeEffect: {
                        crossFade: true,
                    },
                }
            );
        }
    });
};

export default sliderTabs;
